/**
 * Public plan catalog — today only Growth, the single CliniSharp plan. Backs
 * the authenticated /onboarding/billing screen, which reads both charges
 * (Ativação and Evolução contínua) from here and never hard-codes a price.
 * Reads `/v1/public/tiers` (PublicTiersController, no auth, no tenant header).
 *
 * VITE_API_URL baseURL already includes `/api/v1`, so the service path is
 * `/public/tiers` without the prefix (matches every other service in this
 * folder).
 */

import { httpRequest } from "@/lib/axios";

export type PublicTier = {
  key: string;
  name: string;
  /** One-time Ativação in BRL; 0 means the price is not set yet. */
  activation_price_brl: number;
  /** Monthly Evolução contínua in BRL; 0 means the price is not set yet. */
  monthly_price_brl: number;
  annual_price_brl: number | null;
  annual_discount_percent: number | null;
  ai_conversations_monthly_limit: number | null;
  ai_messages_monthly_limit: number | null;
  max_seats: number | null;
  sales_led: boolean;
};

export const PublicTiersAPI = {
  list(): Promise<PublicTier[]> {
    return httpRequest
      .get<{ data: PublicTier[] }>("/public/tiers")
      .then((r) => r.data.data);
  },
};
